"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.validation.stepsRequired': 'Wymagany jest co najmniej jeden krok',
    'tutorial.validation.stepTitleRequired': 'Tytuł kroku {index} jest wymagany',
    'tutorial.validation.stepSectionsRequired': 'Krok {index} musi mieć co najmniej jedną sekcję',
    'tutorial.validation.sectionTitleRequired': 'Tytuł sekcji jest wymagany w Kroku {stepIndex}, Sekcji {sectionIndex}',
    'tutorial.validation.nameRequired': 'Nazwa poradnika jest wymagana',
    'tutorial.validation.sectionsRequired': 'Wymagana jest co najmniej jedna sekcja',
};
